import { render } from "./PosotionImgContentLeft.vue?vue&type=template&id=a1224aa8&scoped=true"
import script from "./PosotionImgContentLeft.vue?vue&type=script&lang=js"
export * from "./PosotionImgContentLeft.vue?vue&type=script&lang=js"

import "./PosotionImgContentLeft.vue?vue&type=style&index=0&id=a1224aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1224aa8"]])

export default __exports__